import React from 'react';
import { graphql } from 'gatsby';
import { ArrowLeft, ArrowRight } from 'akar-icons';

import Link from '../../components/Link/Link';
import Micro from '../../layouts/Micro';
import packageJson from '../../../package.json';

import './sitemap.scss';

const SitemapTemplate = ({ data, pageContext }) => {
  const { previousPagePath, nextPagePath } = pageContext;
  const { allSitePage } = data;

  const allPages = {};

  let siteLinkNodes = allSitePage.edges.length ? allSitePage.edges.map((edge) => edge.node) : [];
  siteLinkNodes = siteLinkNodes
    .filter((item) => !item?.path.includes('%20'))
    .map((siteLinkNode) => ({
      ...siteLinkNode,
      levels: siteLinkNode.path.split('/').filter((level) => level !== ''),
    }));

  siteLinkNodes.forEach((item) => {
    if (item.levels && item.levels.length && item.levels.length === 2) {
      if (!Object.prototype.hasOwnProperty.call(allPages, item.levels[0])) {
        allPages[item.levels[0]] = {};
      }

      if (!Object.prototype.hasOwnProperty.call(allPages, item.levels[1])) {
        allPages[item.levels[0]][item.levels[1]] = item;
      }
    }
  });

  const stripTitle = (title) =>
    `${title
      .substring(0, 30)
      .split('-')
      .slice(0, 4)
      .map((keyword) => keyword.toUpperCase())
      .join(' ')}...`;

  return (
    <Micro>
      <div className="sitemap-wrapper">
        <div className="sitemap-links">
          <h1>Remote Team</h1>
          <h3>Site Map &ndash; v{packageJson.version}</h3>

          <Navigation previousPagePath={previousPagePath} nextPagePath={nextPagePath} />

          <ul>
            <li>
              <a href="https://dashboard.remoteteam.com/auth/sign-up">Sign Up</a>
            </li>
            <li>
              <a href="https://dashboard.remoteteam.com/auth/sign-in">Sign In</a>
            </li>
          </ul>

          <ul>
            <li>
              <a href="/">HOME</a>
            </li>

            {Object.keys(allPages)
              .sort()
              .map((mainCategory) => (
                <li>
                  <a href={`/${mainCategory}`}>{stripTitle(mainCategory)}</a>
                  <ul>
                    {Object.keys(allPages[mainCategory])
                      .sort()
                      .map((item) => (
                        <li>
                          <a href={allPages[mainCategory][item].path}>
                            {allPages[mainCategory][item].levels.length &&
                              stripTitle(
                                allPages[mainCategory][item].levels[
                                  allPages[mainCategory][item].levels.length - 1
                                ]
                              )}
                          </a>
                        </li>
                      ))}
                  </ul>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </Micro>
  );
};

const Navigation = (props) => {
  const { previousPagePath, nextPagePath } = props;
  return (
    <div className="row">
      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-left">
        {previousPagePath && (
          <Link href={previousPagePath} className="button main">
            <ArrowLeft size="12" /> Previous
          </Link>
        )}
      </div>
      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-right">
        {nextPagePath && (
          <Link href={nextPagePath} className="button main">
            <ArrowRight size="12" /> Next
          </Link>
        )}
      </div>
    </div>
  );
};

export const pageQuery = graphql`
  query($skip: Int!, $limit: Int!) {
    allSitePage(sort: { order: ASC, fields: [path] }, skip: $skip, limit: $limit) {
      edges {
        node {
          id
          path
        }
      }
    }
  }
`;

export default SitemapTemplate;
